import React from 'react'
import ReactDOM from 'react-dom'
import './index.css'
import App from './App'
import { BrowserRouter } from 'react-router-dom'
import MainDataContextProvider from './context/mainDataContext'

ReactDOM.render(
  <React.StrictMode>
    <BrowserRouter>
      <MainDataContextProvider>
        <App />
      </MainDataContextProvider>
    </BrowserRouter>
  </React.StrictMode>,
  document.getElementById('root')
)
